export default __webpack_public_path__ + "static/floor1-slide-3-4e544bfb5837fe8b491d467349b32e06.jpg";